// Campus photo for /colleges/montclair-state-university: CC BY-SA 4.0, by Shane Fleming, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACollege_Hall_at_Montclair_State.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/montclair-state-university/; credited under the photo.
const photo = {
    "slug": "montclair-state-university",
    "alt": "The white facade of College Hall behind trees and flower beds at Montclair State University in Montclair, New Jersey",
    "src": "/colleges/montclair-state-university/campus-1600.webp",
    "srcSmall": "/colleges/montclair-state-university/campus-800.webp",
    "srcMid": "/colleges/montclair-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/montclair-state-university/og.jpg",
    "title": "College Hall at Montclair State",
    "author": "Shane Fleming",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACollege_Hall_at_Montclair_State.jpg",
    "read": "2026-10-01"
};

export default photo;
